import React, { Component } from 'react'
import { getBotPlaybooks, savePlaybook, savePlaybookDraft, getSingleFullPB } from 'api/playbooks'
import { clone, append, mergeRight, equals } from 'ramda'
import { tracking } from '@driftt/traffic-control'
import EnrollSegmentInPlaybookModal from './EnrollSegmentInPlaybookModal';

const defaultState = {
  selectedPlaybook: null,
  targetedPlaybook: null,
  selectedEnrollmentType: null,
  isSaving: false,
  segment: null
}

class EnrollSegmentInPlaybook extends Component {
  constructor(props) {
    super(props)

    this.state = mergeRight(defaultState, {
      segment: props.segment
    })
  }

  componentDidMount() {
    this.getPlaybooks()
  }

  static getDerivedStateFromProps(props, state) {
    if (!equals(props.segment, state.segment)) {
      return {
        segment: props.segment
      }
    }

    return null
  }

  getPlaybooks = async () => {
    try {
      const {data: playbooks} = await getBotPlaybooks()

      this.setState({
        playbooksToTarget: playbooks
      })
    } catch (e) {
      console.warn(e)
    }
  }

  getSelectedPlaybook = async (id) => {
    try {
      const {data: fullPB} = await getSingleFullPB(id)

      this.setState({
        selectedPlaybook: fullPB
      })
    } catch(e) {
      console.warn(e)
    }
  } 

  onChoosePlaybook = ({value}) => {
    this.getSelectedPlaybook(value)
  }

  onChooseEnrollmentType = ({value}) => {
    const { selectedPlaybook, segment } = this.state

    const clonedPB = clone(selectedPlaybook)

    delete clonedPB.taskIdentifier

    if (clonedPB.targeting.display.length > 0) {
      clonedPB.targeting.display = clonedPB.targeting.display.map(group => append({field: 'contactSegment', operator: value, value: [segment.id]}, group))
    } else {
      clonedPB.targeting.display = append([{field: 'contactSegment', operator: value, value: [segment.id]}], clonedPB.targeting.display)
    }

    this.setState({
      targetedPlaybook: clonedPB,
      selectedEnrollmentType: value
    })
  }

  setSaveState = () => {
    this.setState(prevState => ({
      isSaving: !prevState.isSaving
    }), this.onAddToBotAudience)
  }

  closeModal = () => {
    const { onClose } = this.props
    this.setState(defaultState, () => onClose())
  }

  onAddToBotAudience = async () => {
    const { onClose, onSaveSuccess } = this.props
    const { targetedPlaybook, segment, selectedEnrollmentType } = this.state

    tracking.trackEvent('Contacts - Enrolled Playbook Segment', {
      segmentType: segment.type,
      enrollment: selectedEnrollmentType
    })
    try {
      await savePlaybook(targetedPlaybook)
      await savePlaybookDraft(targetedPlaybook.id, targetedPlaybook)

      this.setState(defaultState, () => {
        onSaveSuccess(targetedPlaybook.id)
        onClose()
      })
    } catch (e) {
      console.warn(e)
    }
  }

  render() {
    const { playbooksToTarget, selectedPlaybook, selectedEnrollmentType, targetedPlaybook, isSaving, segment} = this.state
    const { open } = this.props

    if (!playbooksToTarget || !segment) {
      return null
    }

    return (
      <EnrollSegmentInPlaybookModal
        open={open}
        playbooksToTarget={playbooksToTarget}
        segment={segment}
        selectedPlaybook={selectedPlaybook}
        targetedPlaybook={targetedPlaybook}
        selectedEnrollmentType={selectedEnrollmentType}
        isSaving={isSaving}
        onChooseEnrollmentType={this.onChooseEnrollmentType}
        onClose={this.closeModal}
        onPlaybookSelect={this.onChoosePlaybook}
        onSave={this.setSaveState}
      />
    )
  }
}

export default EnrollSegmentInPlaybook
